import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import * as d3 from 'd3';
import css_248z from './heatMapChart.styles.css.js';

let HeatMapChart = class HeatMapChart extends LitElement {
    constructor() {
        super(...arguments);
        this.value = 0;
        this.text = '';
    }
    firstUpdated() {
        this.renderChart();
        window.addEventListener('resize', () => this.renderChart());
    }
    updated(changedProps) {
        if (changedProps.has('value') || changedProps.has('text')) {
            this.renderChart();
        }
    }
    getCssVar(name) {
        return getComputedStyle(this).getPropertyValue(name).trim();
    }
    renderChart() {
        var _a;
        const svgEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('svg');
        if (!svgEl)
            return;
        const { width } = svgEl.getBoundingClientRect();
        const margin = { top: 60, right: 20, left: 20 };
        const innerWidth = width - margin.left - margin.right;
        const svg = d3.select(svgEl).html('');
        const colorStart = this.getCssVar('--color-range-start');
        const colorMid = this.getCssVar('--color-range-mid');
        const colorEnd = this.getCssVar('--color-range-end');
        const colorScale = d3
            .scaleLinear()
            .domain([0, 50, 100])
            .range([colorStart, colorMid, colorEnd]);
        const numSegments = 10;
        const gap = 5;
        const totalGap = (numSegments - 1) * gap;
        const segmentWidth = (innerWidth - totalGap) / numSegments;
        const height = 20;
        const radius = 4;
        for (let i = 0; i < numSegments; i++) {
            const start = i * 10;
            const xPos = margin.left + i * (segmentWidth + gap);
            const fill = colorScale(start + 5);
            if (i === 0) {
                // Primer bloque con border-radius solo en la izquierda
                const path = `
          M ${xPos + radius},${margin.top}
          H ${xPos + segmentWidth}
          V ${margin.top + height}
          H ${xPos + radius}
          A ${radius},${radius} 0 0 1 ${xPos},${margin.top + height - radius}
          V ${margin.top + radius}
          A ${radius},${radius} 0 0 1 ${xPos + radius},${margin.top}
          Z
        `;
                svg.append('path').attr('d', path).attr('fill', fill);
            }
            else if (i === numSegments - 1) {
                // Último bloque con border-radius solo en la derecha
                const path = `
          M ${xPos},${margin.top}
          H ${xPos + segmentWidth - radius}
          A ${radius},${radius} 0 0 1 ${xPos + segmentWidth},${margin.top + radius}
          V ${margin.top + height - radius}
          A ${radius},${radius} 0 0 1 ${xPos + segmentWidth - radius},${margin.top + height}
          H ${xPos}
          Z
        `;
                svg.append('path').attr('d', path).attr('fill', fill);
            }
            else {
                // Bloques intermedios sin border-radius
                svg
                    .append('rect')
                    .attr('x', xPos)
                    .attr('y', margin.top)
                    .attr('width', segmentWidth)
                    .attr('height', height)
                    .attr('fill', fill);
            }
        }
        const x = d3
            .scaleLinear()
            .domain([0, 100])
            .range([margin.left, margin.left + innerWidth]);
        const xAxis = d3
            .axisBottom(x)
            .ticks(numSegments)
            .tickFormat((d) => d)
            .tickSize(0);
        svg
            .append('g')
            .attr('transform', `translate(0, ${margin.top + 30})`)
            .call(xAxis)
            .attr('class', 'axis')
            .selectAll('text')
            .attr('fill', 'var(--heatmap-number-scale-color)')
            .style('font-size', '12px');
        const companyX = x(this.value + 0.15);
        svg
            .append('line')
            .attr('x1', companyX)
            .attr('x2', companyX)
            .attr('y1', margin.top - 25)
            .attr('y2', margin.top - 5)
            .attr('stroke', 'var(--heatmap-text-color)')
            .attr('stroke-width', 2);
        const text = `${this.value}% (${this.text})`;
        const textElement = svg
            .append('text')
            .attr('y', margin.top - 35)
            .attr('class', 'label')
            .attr('stroke', 'var(--heatmap-text-color)')
            .text(text);
        const textNode = textElement.node();
        const textWidth = textNode.getBBox().width;
        let adjustedX = companyX;
        if (companyX - textWidth / 2 < margin.left) {
            adjustedX = margin.left + textWidth / 2;
        }
        else if (companyX + textWidth / 2 > width - margin.right) {
            adjustedX = width - margin.right - textWidth / 2;
        }
        textElement.attr('x', adjustedX);
    }
    render() {
        return html `<svg></svg>`;
    }
};
HeatMapChart.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: Number })
], HeatMapChart.prototype, "value", void 0);
__decorate([
    property({ type: String })
], HeatMapChart.prototype, "text", void 0);
HeatMapChart = __decorate([
    customElement('ht-heat-map-chart')
], HeatMapChart);
var HeatMapChart$1 = HeatMapChart;

export { HeatMapChart$1 as default };
//# sourceMappingURL=heatMapChart.js.map
